export const PROXY_PREFIX = '/dynaform/api';
